// @flow
import type { AppState } from 'stores'
import { MunicipalityDetail } from 'components/municipalityDetail/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'

export { MunicipalityDetail } from './component'

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({
  activeMunicipality,
  valuesByMunicipality,
  categorySelection
}: AppState) => {
  let currentMunicipality = valuesByMunicipality.get(
    activeMunicipality.toString()
  )
  return {
    ...currentMunicipality,
    ...categorySelection,
    activeMunicipality
  }
}

const hideIfWrongActiveMunicipality = branch(
  props => props.activeMunicipality <= 0,
  renderNothing
)

export default connect(mapStateToProps, undefined)(
  hideIfWrongActiveMunicipality(MunicipalityDetail)
)



// WEBPACK FOOTER //
// ./src/components/municipalityDetail/index.js